<template>
  <van-list class="list-result">
    <van-swipe-cell v-for="(el, index) in elenco" :key="index" :stop-propagation="true">
      <template #left>
        <van-button square color="#5badfa" text="Seleziona" class="swipe-cell-button" @click="seleziona(el)"/>
      </template>
      <van-cell
        :border="true"
        :title="el.titolo"
        :value="el.value"
        :title-class="titleClass"
        :label-class="labelClass"
        :value-class="valueClass"
        :icon="cellIcon"
        size="large"
        @click="seleziona(el)"
      >
        <template #label>
          <div>
            {{ el.label }}<br v-if="el.fornitoreDescrizione" />
            <span v-if="el.fornitoreDescrizione">Fornitore: {{ el.fornitoreDescrizione }}</span>
          </div>
        </template>
      </van-cell>
       <!-- Menu a tendina per le giacenze -->
      <van-collapse v-model="expandedItems" :accordion="true" style="margin-bottom: 10px">
        <van-collapse-item style="border-bottom: 1px solid grey;" :name="index" v-if="hasGiacenze(el)">
          <template #title >
            <div style="display: flex; justify-content-right">Dettagli Giacenze</div>
          </template>
          <div>
            <van-cell
              v-for="(giacenza, magazzino) in getGiacenze(el)"
              :key="magazzino"
              :title="`Giacenza ${magazzino}`"
              :value="giacenza"
              size="small"
              :title-class="titleClass"
              :value-class="valueClass"
            />
          </div>
        </van-collapse-item>
      </van-collapse>
      <template #right v-if="rightAction">
        <van-button square color="#5badfa" :text="rightActionLabel" class="swipe-cell-button" @click="rightActionSelect(el)"/>
      </template>
    </van-swipe-cell>
  </van-list>
</template>

<script>
/* eslint-disable */
export default {
  props: {
    rightAction: {
      type: Boolean,
      default: false
    },
    rightActionLabel: {
      type: String
    }
  },
  data() {
    return {
      lastTouch: null,
      lockSelection: false,
      timerReset: null,
      expandedItems: [], // Indice degli elementi espansi
    }
  },
  mounted() {
    var that = this
    window.addEventListener('touchstart', function (event) {
      that.lastTouch = event.touches[0]
    })
    window.addEventListener('touchend', function (event) {
      that.lastTouch = null
      that.timerReset = setTimeout(() => {
        that.lockSelection = false
      }, 300)
    })
    window.addEventListener('touchmove', function (event) {
      var currentTouch = event.changedTouches[0]
      var target = document.querySelector('.list-result')
      if (that.lastTouch && target) {
        target.scrollTop -= (currentTouch.clientY - that.lastTouch.clientY)
        that.lockSelection = true
        that.timerReset = null
      }
      that.lastTouch = currentTouch
    })
  },
  computed: {
    elenco() {
      console.log(this.$store.getters.listResultSource)
      return this.$store.getters.listResultSource
    },
    altezzaLista() {
      var ht = this.$store.getters.keyboardHeight || 300
      console.log('altezzaLista', ht)
      return ht
    },
    cellIcon() {
      return this.$store.getters.listResultItemIcon
    },
    titleClass() {
      return this.$store.getters.listResultItemClasses.titleClass
    },
    labelClass() {
      return this.$store.getters.listResultItemClasses.labelClass
    },
    valueClass() {
      return this.$store.getters.listResultItemClasses.valueClass
    }
  },
  methods: {
    seleziona(item) {
      if (this.lockSelection) {
        return
      }
      this.$store.commit('SET_POPUP_LIST_RESULT', item)
    },
    /*     beforeClose({ position, instance }) {
      console.log('position', position)
    }, */
    rightActionSelect(el) {
      this.$emit('click-right', el)
    },
    // Controlla se esistono campi di giacenza
    hasGiacenze(el) {
      return Object.keys(el).some((key) => key.startsWith("giacenza_"));
    },
    // Filtra i campi di giacenza e restituisce un oggetto chiave-valore
    getGiacenze(el) {
      return Object.keys(el)
        .filter((key) => key.startsWith("giacenza_"))
        .reduce((acc, key) => {
          acc[key.replace("giacenza_", "")] = el[key]; // Rimuove il prefisso "giacenza_"
          return acc;
        }, {});
    },
  }
}
</script>

<style lang="scss" scoped>
  .swipe-cell-button {
    height: 100%;
  }
  
/*   .prodotti-lr-value {
  }

  .prodotti-lr-title {
  }
  .prodotti-lr-label {
  } */
</style>
